import { useLang } from "@/i18n";
import { SectionHeading, Reveal } from "@/components/Reveal";

const Column = ({ title, items, testid }) => (
  <Reveal className="h-full">
    <div className="h-full border hairline rounded-sm bg-obsidian-surface/60 p-8 lg:p-10" data-testid={testid}>
      <h3 className="font-serif text-xl sm:text-2xl font-medium text-gold">{title}</h3>
      <div className="mt-3 w-10 h-px bg-gold/60" />
      <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
        {items.map((item, i) => (
          <li key={item} data-testid={`${testid}-item-${i}`} className="flex items-start gap-3 text-sm sm:text-[15px] font-light text-slate-300 leading-relaxed">
            <span className="mt-[7px] w-1.5 h-1.5 rotate-45 bg-gold/70 shrink-0" />
            {item}
          </li>
        ))}
      </ul>
    </div>
  </Reveal>
);

export default function Stakeholders() {
  const { t } = useLang();
  return (
    <section id="stakeholders" className="py-24 lg:py-32 bg-obsidian-surface" data-testid="stakeholders-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading overline={t.stakeholders.overline} title={t.stakeholders.title} testid="stakeholders-title" />
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <Column title={t.stakeholders.leftTitle} items={t.stakeholders.left} testid="stakeholders-africa" />
          <Column title={t.stakeholders.rightTitle} items={t.stakeholders.right} testid="stakeholders-world" />
        </div>
      </div>
    </section>
  );
}
